import script from "./cpt-ring-pie.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-ring-pie.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__